import toast from "react-hot-toast";
import { SORT_ORDER, ORDER_EXECUTION_TYPE, ORDER_STATE_TYPE, STORAGE_KEYS } from "./key_helper";
export const formatStanderdTimeString = (inputTime) => {
    if (!inputTime) return "";
    const inputDate = new Date(inputTime);

    // Check if inputDate is a valid date
    if (!isNaN(inputDate.getTime())) {
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
        const day = inputDate.getDate().toString().padStart(2, "0");
        const hours = inputDate.getHours().toString().padStart(2, "0");
        const minutes = inputDate.getMinutes().toString().padStart(2, "0");
        const seconds = inputDate.getSeconds().toString().padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else {
        // If inputTime is not a valid date, return it as is (assumed to be in "hh:mm:ss" format)
        return inputTime;
    }
};
export const formatStanderdDateString = (inputTime) => {
    if (!inputTime) return "";
    const inputDate = new Date(inputTime);

    // Check if inputDate is a valid date
    if (!isNaN(inputDate.getTime())) {
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
        const day = inputDate.getDate().toString().padStart(2, "0");

        return `${year}-${month}-${day} `;
    } else {
        // If inputTime is not a valid date, return it as is (assumed to be in "hh:mm:ss" format)
        return inputTime;
    }
};
// Function For Get Current Date 
export const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
// Function For Get Date Before 30 Days 
export const getDateBefore30Days = () => {
    const today = new Date();
    today.setDate(today.getDate() - 30); // Subtract 30 days from the current date
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
//Function to gt Current Date and time For export file name
export function getYMDHMSFormat() {
    const date = new Date();
    // Convert to Indian Standard Time (IST)
    const istDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    // Format date as "yyyyMMdd"
    const year = istDate.getFullYear();
    const month = (istDate.getMonth() + 1).toString().padStart(2, "0");
    const day = istDate.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}${month}${day}`;
    // Format time as "hhmmss" in 24-hour format
    const hours = istDate.getHours().toString().padStart(2, "0");
    const minutes = istDate.getMinutes().toString().padStart(2, "0");
    const seconds = istDate.getSeconds().toString().padStart(2, "0");
    const formattedTime = `${hours}${minutes}${seconds}`;
    // Combine date and time with an underscore separator
    return `${formattedDate}_${formattedTime}`;
}
//Copy To clipboard function
export const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        // Use the modern Clipboard API if available
        navigator.clipboard.writeText(text).then(() => {
            toast.success("Copied successfully!", { hideAfter: 3, });
        })
            .catch((err) => {
                console.log("Failed to copy text with Clipboard API:", err);
            });
    } else {
        // Fallback for older browsers
        try {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.position = "fixed"; // Avoid scrolling to the bottom
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            toast.success("Text Copied", { hideAfter: 3, });
        } catch (err) {
            console.error("Fallback: Unable to copy text", err);
        }
    }
};

export const handleSearchSortData = (
    data,
    searchValue,
    searchFields,
    selectedSortOption,
    sortOrder
) => {
    if (!data) return [];
    let filteredData = [...data];

    // --- Search ---
    if (searchValue) {
        const lowercasedSearch = searchValue.toLowerCase();

        filteredData = filteredData?.filter((item) =>
            searchFields?.some((field) => {
                const value = item[field];
                if (value == null) return false; // skip null/undefined
                return value.toString().toLowerCase().includes(lowercasedSearch);
            })
        );
    }

    // --- Sort ---
    if (selectedSortOption) {
        const field = selectedSortOption.value;

        const getValue = (obj) => {
            if (field in obj) return obj[field];
            if (obj.account_info && field in obj.account_info)
                return obj.account_info[field];
            return undefined;
        };

        filteredData.sort((a, b) => {
            const valueA = getValue(a);
            const valueB = getValue(b);

            // Handle null/undefined
            if (valueA == null) return 1;
            if (valueB == null) return -1;

            // Strings
            if (typeof valueA === "string" && typeof valueB === "string") {
                return sortOrder === SORT_ORDER.ASCENDING
                    ? valueA.localeCompare(valueB)
                    : valueB.localeCompare(valueA);
            }

            // Numbers or other types (safely convert)
            const numA = Number(valueA ?? 0);
            const numB = Number(valueB ?? 0);

            return sortOrder === SORT_ORDER.ASCENDING ? numA - numB : numB - numA;
        });
    }

    return filteredData;
};

// A function to get the value of a CSS variable
export const getCssVariable = (variableName) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
};
export const getOrderTypeName = (type) => {
    return ORDER_EXECUTION_TYPE[type] || 'Unknown'; // Return 'Unknown' if type is not found
}
export const getOrderStateName = (type) => {
    return ORDER_STATE_TYPE[type] || 'Unknown'; // Return 'Unknown' if type is not found
}
// Utility function to format date to display format
export function formatDisplayDate(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0"); // local day
    const month = new Intl.DateTimeFormat('en-GB', { month: 'short' }).format(date); // local month
    const year = date.getFullYear(); // local year

    return `${day} ${month} ${year}`;
}

// Function to get the capitalized first letter of the fullname
export const getFirstLetterCapitalized = (name) => {
    if (!name) return "";
    const trimmedName = name.trimStart(); // Remove leading spaces
    return trimmedName.charAt(0).toUpperCase();
};

// Function to extract the main domain from a URL
export function extractMainDomain(url) {
    if (!url) return "";

    // Remove protocol (http, https, etc.)
    let ret_name = url.replace(/(^\w+:|^)\/\//, '');
    // Remove www. if present
    if (ret_name.startsWith('www.')) {
        ret_name = ret_name.substring(4);
    }
    // Remove path and query params
    ret_name = ret_name.split('/')[0].split('?')[0];
    return ret_name;
}
export function getDomainName(need_flat = false) {
    const base_url = window.location.origin;
    let final_url = base_url;
    if (
        base_url.includes("localhost") ||
        base_url.includes("192.168") ||
        base_url.includes("127.0.0.1")
    ) {
        final_url = "https://forex.investmentvidhya.com";
    }

    if (need_flat) {
        return extractMainDomain(final_url).replaceAll(".", "_");
    }
    return final_url;
}
// Function to get primary color from the root 
export const getPrimaryColor = () => {
    return getComputedStyle(document.documentElement)
        .getPropertyValue('--color-primary')
        .trim()
};